<template>
    <b-modal
      size="lg"
      :hideFooter="true"
      id="userAddModal"
      @hide="resetModal"
      @show="resetModal"
    >
      <template slot="modal-title">
        <h5>
          <em class="fas fa-user-plus"></em> Добавление пользователя
        </h5>
      </template>
      <template slot="default">
        <b-container>
          <b-form
            @submit.prevent="onSubmit"
          >
            <b-row class="userModalItem">
              <b-col sm="3">
                <label> E-mail: </label>
              </b-col>
              <b-col sm="9">
                <b-form-input type='email' required v-model="form.email"></b-form-input>
              </b-col>
            </b-row>
            <b-row class="userModalItem">
              <b-col sm="3">
                <label> Фамилия: </label>
              </b-col>
              <b-col sm="9">
                <b-form-input type='text' required v-model="form.surname"></b-form-input>
              </b-col>
            </b-row>
            <b-row class="userModalItem">
              <b-col sm="3">
                <label> Имя: </label>
              </b-col>
              <b-col sm="9">
                <b-form-input type='text' required v-model="form.name"></b-form-input>
              </b-col>
            </b-row>
            <b-row class="userModalItem">
              <b-col sm="3">
                <label> Отчество: </label>
              </b-col>
              <b-col sm="9">
                <b-form-input type='text' v-model="form.midname"></b-form-input>
              </b-col>
            </b-row>
            <b-row class="userModalItem">
              <b-col sm="3">
                <label> Организация: </label>
              </b-col>
              <b-col sm="9">
                <b-form-select v-model="form.organisationId" required>
                  <optgroup label="Подразделения Газпром">
                    <option v-for="(org, index) in organizations.filter((p) => p.type
                    === 'Подразделение')" :value="org.id" :key="index">{{org.title}}</option>
                  </optgroup>
                  <optgroup label="Классы">
                    <option v-for="(org, index) in organizations.filter((p) => p.type
                    === 'ГП-класс')" :value="org.id" :key="index">{{org.title}}</option>
                  </optgroup>
                  <optgroup label="Вузы, СПО">
                    <option
                      v-for="(org, index) in organizations.filter((p) => p.type
                        === 'ВУЗ' || p.type === 'СПО')"
                      :value="org.id"
                      :key="index"
                    >
                      {{org.title}}
                    </option>
                  </optgroup>
                </b-form-select>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="3">
                <label> Роли: </label>
              </b-col>
              <b-col sm="9">
                <b-form-checkbox-group v-model="form.roles" stacked>
                  <b-form-checkbox
                    v-for="(role, index) in allRoles"
                    :key="index"
                    :value="role"
                  > {{ $_userMixin_roleTranslate(role) }} </b-form-checkbox>
                </b-form-checkbox-group>
              </b-col>
            </b-row>
            <b-row class="mb-3 sm userModal-footer">
              <b-col sm="12" md="12" lg="6" class="ml-auto sm p-3">
                  <b-btn
                    variant="primary"
                    class="float-right userModal-confirmButton"
                    type="submit"
                  >
                    <em class="fas fa-paper-plane"></em> Отправить приглашение
                  </b-btn>
              </b-col>
            </b-row>
          </b-form>
        </b-container>
      </template>
    </b-modal>
</template>

<script>

import { mapActions, mapGetters } from 'vuex'

import UserMixin from '@/components/helpers/mixins/user-mixin'

import invitationApi from '@/api/invitation'
import { roles } from '@/config/roles'
import { regexp } from '@/config/regexp'

export default {
  name: 'UserAddModal',
  mixins: [UserMixin],
  data() {
    return {
      form: {
        email: '',
        surname: '',
        name: '',
        midname: '',
        organisationId: '',
        roles: []
      },
      roles_: roles,
      allRoles: Object.values(roles).filter((role) => role !== roles.student),
      nameRegExp: regexp.name
    }
  },
  computed: {
    ...mapGetters({
      organizations: 'dicts/getOrganizations'
    })
  },
  methods: {
    onSubmit() {
      if (this.validateEmail(this.form.email)) {
        if (!this.form.name.match(this.nameRegExp)) {
          this.pushToasts({
            title: 'Уведомление',
            error: true,
            message: 'Некорректный ввод имени!'
          })
          return
        }
        if (!this.form.surname.match(this.nameRegExp)) {
          this.pushToasts({
            title: 'Уведомление',
            error: true,
            message: 'Некорректный ввод фамилии!'
          })
          return
        }
        if (this.form.midname && !this.form.midname.match(this.nameRegExp)) {
          this.pushToasts({
            title: 'Уведомление',
            error: true,
            message: 'Некорректный ввод отчества!'
          })
          return
        }
        if (!this.form.roles || !this.form.roles.length) {
          this.pushToasts({
            title: 'Уведомление',
            error: true,
            message: 'Не выбраны роли пользователя в системе!'
          })
          return
        }
        invitationApi.sendInvitationsOtherUsers(this.form.midname ? this.form : {
          ...this.form,
          midname: null
        })
          .then(() => {
            this.pushToasts({
              title: 'Уведомление',
              message: 'Приглашение успешно отправлено.'
            })
            this.$bvModal.hide('userAddModal')
          })
          .catch((error) => {
            this.pushToasts({
              title: 'Уведомление',
              error: true,
              message: error.response.data.errors[0]
            })
          })
      } else {
        this.pushToasts({
          title: 'Уведомление',
          error: true,
          message: 'Некорректный ввод почты!'
        })
      }
    },
    resetModal() {
      this.form = {}
    },
    validateEmail(email) {
      const re = regexp.email
      return re.test(String(email).toLowerCase())
    },
    ...mapActions({
      pushToasts: 'toasts/pushToasts'
    })
  }
}
</script>

<style scoped>

  textarea:focus,
  textarea:not(focus),
  textarea:active {
    outline: none !important;
    box-shadow: none !important;
    border: 1px lightgrey solid !important;
    border-right: none !important;
  }

  .userModal-header {
    margin-bottom: 30px;
  }

  .userModalItem {
    margin-bottom: 20px;
  }

  .userModal-footer {
    margin-bottom: 0 !important;
  }

  .userModal-confirmButton {
    width: 100%;
  }

</style>
